import {ConfigsList} from "./ConfigsList";
import {ConfigsEdit} from "./ConfigsEdit";


export default {
    list: ConfigsList,
    create: null,
    edit: ConfigsEdit,
};
